import { render, staticRenderFns } from "./brandList.vue?vue&type=template&id=54732872&scoped=true"
import script from "./brandList.vue?vue&type=script&lang=js"
export * from "./brandList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54732872",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54732872')) {
      api.createRecord('54732872', component.options)
    } else {
      api.reload('54732872', component.options)
    }
    module.hot.accept("./brandList.vue?vue&type=template&id=54732872&scoped=true", function () {
      api.rerender('54732872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/videoChannel/weChatcategoryAndBrand/brandList.vue"
export default component.exports